import React from "react";
import { Dropdown } from "react-bootstrap";
// import { Dropdown } from "bootstrap";
import Prodata from "../data/Prodata";
function Shop() {
  return (
    <div className="container-fluid">
      <h1>Shop</h1>
      <div className="bg pb-5 px-3">
        <div className="container pt-5">
          <div className="row">
            <div className="col-lg-9">
              <div className="d-flex">
                <p className="text-start fw-normal fs-4 mb-0">Showing Results</p>
                <select className="form-select ms-auto sort" aria-label="Default select example">
                  <option selected>Default Sorting</option>
                  <option value={1}>Sort by popularity</option>
                  <option value={2}>Sort by average rating</option>
                  <option value={3}>Sort by latest</option>
                  <option value={4}>Sort by price:low to high</option>
                  <option value={5}>Sort by price:high to low</option>
                </select>
              </div>
               <div className="row">
                {Prodata.map((a) => (
                  <div className="col-lg-6">
                    <div className="card shop mt-4">
                      <img className="w-100" src={a.image} />
                      <div className="card-body text-center">
                        <h5 className="text-body fw-semibold py-3">{a.title}</h5>
                        <h5 className="fw-normal text-primary-emphasis py-2">{a.price}</h5>
                        <div className="star py-3">
                          <i class="bi bi-star-fill pe-2 text-warning"></i>
                          <i class="bi bi-star-fill pe-2 text-warning"></i>
                          <i class="bi bi-star-fill pe-2 text-body-tertiary"></i>
                          <i class="bi bi-star-fill text-body-tertiary pe-2"></i>
                          <i class="bi bi-star-fill text-body-tertiary"></i>
                        </div>
                        <button type="button" class="btn my-3 px-4 know rounded-pill">Add To Cart</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-3 ">
              <div className="border ms-3 py-3 px-4">
                <h5>Product Categories</h5>
                <p className="pt-4 pb-2">Clothing (12)</p>
                <div className="ps-4">
                  <div className="d-flex border-bottom border-dark-subtle">
                    <i class="bi bi-caret-right-fill pe-2"></i>
                    <p>Hoodies (6)</p>
                  </div>
                </div>
                <div className="ps-4 pt-4  border-bottom border-dark-subtle">
                  <div className="d-flex">
                    <i class="bi bi-caret-right-fill pe-2"></i>
                    <p>T-Shirts (6)</p>
                  </div>
                </div>
                <p className="pt-4 pb-2">Music (6)</p>
                <div className="ps-4">
                  <div className="d-flex border-bottom border-dark-subtle">
                    <i class="bi bi-caret-right-fill pe-2"></i>
                    <p>Albums (4)</p>
                  </div>
                </div>
                <div className="ps-4 pt-4 border-bottom border-dark-subtle">
                  <div className="d-flex">
                    <i class="bi bi-caret-right-fill pe-2"></i>
                    <p>Singles (2)</p>
                  </div>
                </div>
                <p className="pb-3 pt-4 border-bottom border-dark-subtle">
                  Posters (5)
                </p>
                <p className="pb-2">Uncategorized (0)</p>
              </div>
              <div className="border mt-4 p-3 ms-3">
                <h4>Filter By Price</h4>
                <div>
                  <p className="mb-0 mt-2">Hoodies</p>
                  <div className="progress mb-3" role="progressbar" aria-label="Default striped example" aria-valuenow={10} aria-valuemin={0} aria-valuemax={100}>
                    <div className="progress-bar progress-bar-striped" style={{ width: "10%" }}/></div>
                  <p className="mb-0 mt-2">T-Shirts</p>
                  <div className="progress mb-3" role="progressbar" aria-label="Success striped example" aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}>
                    <div className="progress-bar progress-bar-striped bg-success" style={{ width: "25%" }}/>
                  </div>
                  <p className="mb-0 mt-2">Albums</p>
                  <div className="progress mb-3" role="progressbar" aria-label="Info striped example" aria-valuenow={50} aria-valuemin={0} aria-valuemax={100}>
                    <div className="progress-bar progress-bar-striped bg-info" style={{ width: "50%" }}/>
                  </div>
                  <p className="mb-0 mt-2">Singles</p>
                  <div className="progress mb-3" role="progressbar" aria-label="Warning striped example" aria-valuenow={75} aria-valuemin={0} aria-valuemax={100}>
                    <div className="progress-bar progress-bar-striped bg-warning" style={{ width: "75%" }}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Shop;
